import { APIDownError, BasketCartConfirmationUrl, MyAccountUrl, CheckoutSummaryAgreementCheckBoxError } from "../directives/utilities/urls";

export default function basketCartSummary() {
    return {
        cardListDetails: [],    
        showErrorMesage: "",
        message: "",
        showLoader: false,
        total_Amount: '',
        isSubmitting: false,
        profileList: '',
        peopleList: '',
        addressDetails: '',
        selectedAgreementChecked:false,
        phoneDetails: '',
        people: '',
        basketTotal: 0,

        bindCardDetails() {
            this.showLoader = true;
            fetch("/api/Checkout/card-details", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {

                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined) {
                        this.cardListDetails = response;

                    } else {
                        this.showErrorMesage = APIDownError;
                    }
                });
        },
        btnCancelClick() {
            this.showLoader = true;
            fetch("/api/Basket/cancel-declare-candidacy", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        window.location.href = MyAccountUrl;
                    } else {
                        this.showErrorMesage = APIDownError;
                    }
                });
        },

        validateNextStep() {
            if (this.selectedAgreementChecked == false) {
                this.message = CheckoutSummaryAgreementCheckBoxError;
                return false;

            } else {

                document.getElementById('btnSubmit').click();
            }
        },
        nextStep() {

            this.isSubmitting = true;

            fetch('/api/basket/complete-basket-checkout', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    AgreementChecked: true,
                    SessionId: '1111',
                    IpAddress: document.getElementById('ipAddress').value
                })
            }).then(response => {
                return response.json();
            }).then(result => {
                document.getElementsByClassName("f-button is-close-btn")[0].click();
                if (result.isSuccess && result.checkoutConfirmed) {
                    document.location.href = BasketCartConfirmationUrl;
                }
                else {
                    this.message = result.message;
                    document.getElementById('btnFailedMessage').click();
                }
                this.isSubmitting = false;
 
            })
        },
        bindProfile() {
            fetch('/api/UserAPI/GetProfile', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    if (response != undefined && response.isSuccess) {
                        this.peopleList = response.people;
                        //If 1 then show Local Address object
                        //If 2 then Business Address
                        //If 3 then Permanent Address
                        if (response.people.preferredAddressType == 1) {
                            this.addressDetails = response.localAddress;
                        } else if (response.people.preferredAddressType == 2) {
                            this.addressDetails = response.businessAddress;
                        } else {
                            this.addressDetails = response.permanentAddress;
                        } this.phoneDetails = response.phoneDetails;
                        this.people = response.people;
                        

                    } else {
                        this.showErrorMesage = APIDownError;
                    }

                });

        },
        cancelBasketClick() {
            if (confirm("Are you sure you want to cancel this request?")) {
                this.showLoader = true;

                fetch("/api/Basket/cancel-declare-candidacy", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },

                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            window.location.href = MyAccountUrl;
                        } else {
                            this.showErrorMesage = APIDownError;
                        }
                    });
            }

        },

        bindBasketList() {
            this.showLoader = true;
    
            this.enrollmentCartList = [];
            fetch("/api/Basket/GetBasketList", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        if (response.basketList.length > 0) {
                            this.basketTotal = response.basketTotal;
                            Array.prototype.push.apply(this.enrollmentCartList, response.basketList);
                        } else {
                            window.location.href =MyAccountUrl;
                        }
                    } else {
                        this.showErrorMesage = APIDownError;
                    }
                });
        },
        formatDate(dateValue) {
            const date = new Date(dateValue);
            const month = date.getMonth() + 1; // Month is zero-based, so add 1
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        },
        init() {
            this.bindProfile();
            this.bindCardDetails();
            this.bindBasketList();
        },
    };
}
